$(document).ready(function(){
    $("#write-a-review").click(function(){
    $(".jdgm-write-rev-link").addClass("close-form-btn");
    $(".jdgm-write-rev-link").text("Cancel review");
    $(".jdgm-form-wrapper").show();
    var $container = $("html,body");
    var $scrollTo = $('.jdgm-write-rev-link');
    $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0},300); 
  });

  
  $('body').on('DOMSubtreeModified', '.boost-pfs-filter-tree', function(){
    $(".boost-pfs-filter-option").each(function(){
      var optext = $(this).find(".boost-pfs-filter-option-title-text").text();
      var matchText = "By Tree Height"
      if(optext.indexOf(matchText) > -1){
        $(this).addClass("tree-height-block");
        
      }
    });
  });
  
  $('body').on('DOMSubtreeModified', '.boost-pfs-filter-tree', function(){
    $(".boost-pfs-filter-option").each(function(){
      var optext = $(this).find(".boost-pfs-filter-option-title-text").text();
      var matchText = "By Realism"
      if(optext.indexOf(matchText) > -1){
        $(this).addClass("realism-block");
        
      }
    });
  });
  
  $('body').on('DOMSubtreeModified', '.boost-pfs-filter-tree', function(){
    $(".boost-pfs-filter-option").each(function(){
      var optext = $(this).find(".boost-pfs-filter-option-title-text").text();
      var matchText = "By Shape"
      if(optext.indexOf(matchText) > -1){
        $(this).addClass("shape-block");
        
      }
    });
  });
  
  $(document).on('classAdded', '.boost-pfs-filter-tree', function(event, className) {
    
    if(className == "tree-height-block") { 
       $(".boost-pfs-filter-option-value").each(function(){
        var heightVal = $(this).text();
        if(heightVal.indexOf("3 Foot") > -1){
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/xsmall-height-tree.png'/> " );
        }
        if(heightVal.indexOf("6-6.5 Foot") > -1){
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/small-height-tree.png'/> " );
        }
        if(heightVal.indexOf("7-6.5 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/medium-height-tree.png' />");
        }
        if(heightVal.indexOf("7-7.5 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/medium-height-tree.png' />");
        }
        if(heightVal.indexOf("8 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/medium-height-tree.png' />");
        }
        if(heightVal.indexOf("9 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/large-height-tree.png' />");
        }
        if(heightVal.indexOf("10 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/xlarge-height-tree.png' />");
        }
        if(heightVal.indexOf("12 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/xlarge-height-tree.png' />");
        }
        if(heightVal.indexOf("15 Foot") > -1){
        	$(this).prepend("<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/xxlarge-height-tree.png' />");
        }
        
      });
    }
    if(className == "realism-block") { 
       $(".boost-pfs-filter-option-value").each(function(){
        var heightVal = $(this).text();
        if(heightVal.indexOf("Realistic") > -1){
          
          $(this).html("<h3>Realistic</h3>");
          $(this).append("<p>high-density PE tree that feels and looks like a real evergreen</p>");
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/realistic.png'/> " );
        }
        if(heightVal.indexOf("Classic") > -1){
          $(this).html("<h3>Classic</h3>");
          $(this).append("<p>A classic & affordable style cut into fine strands to resemble evergreen needles</p>");
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/classic.png'/> " );
          
        }
        
      });
      
    }
    if(className == "shape-block") { 
       $(".boost-pfs-filter-option-value").each(function(){
        var heightVal = $(this).text();
        if(heightVal.indexOf("Wreath") > -1){
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/wreath.png' style='width:46px;height:auto'/> " );
        }
        if(heightVal.indexOf("Garland") > -1){
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/garland.png' style='width:43px;height:auto'/> " );
          
        }
         if(heightVal.indexOf("Tabletop") > -1){
          $(this).prepend( "<img src='https://cdn.shopify.com/s/files/1/0130/8226/3616/files/treetop1.png' style='width:43px;height:auto'/> " );
          
        }
        
      });
      
    }
  });
  $(".slideLink").click(function(){
   var loc = $(this).data("loc");
    $("#slickDot0"+loc).trigger("click");
  });
  $(".CatLink").click(function(){
    $(".CatLink").each(function(){
      if($(this).parent().hasClass("vactiveLink")){
      	$(this).parent().removeClass("vactiveLink");
      }
    });
   var catLink = $(this).parent().data("catgy");
    $(this).parent().addClass("vactiveLink");
    $(".videoItemBlock").each(function(){
      if($(this).hasClass("displayvBlock")){
    	$(this).removeClass("displayvBlock");
      }
      if($(this).hasClass("displaycBlock")){
    	$(this).removeClass("displaycBlock");
      }
    });
    var ccount = 0;
    $(".videoItemBlock").each(function(){
      var chandle = $(this).data("chandle");
      if(chandle == catLink){
        $(this).addClass("displaycBlock");
         if(ccount == 6){
        	$(this).css("clear","both");
        }
        ccount++;
       
      }
      else{
        $(this).addClass("displayvBlock");
      }
    });
  });
  $("#search-txt").keypress(function() {
    var searchVal = $.trim($("#search-txt").val());
    var searchValLow = searchVal.toLowerCase();
    if(searchVal.length > 3){
      $(".videoItemBlock").each(function(){
        if($(this).hasClass("displayvBlock")){
          $(this).removeClass("displayvBlock");
        }
        if($(this).hasClass("displaycBlock")){
          $(this).removeClass("displaycBlock");
        }
      });
      var ccount = 0;
      $(".videoItemBlock").each(function(){
        var cText = $(this).text();
        
        var res = $.trim(cText.toLowerCase());
         var index1 = res.indexOf(searchValLow);    
    	console.log(res+"---"+searchVal+"**"+index1);
        if(index1 !== -1){
          $(this).addClass("displaycBlock");
           if(ccount == 6){
        	$(this).css("clear","both");
        }
        ccount++;
       
        }
        else{
          $(this).addClass("displayvBlock");
        }
      });
    }
  });
  var blogItem = 0;
  $(".blogItem").each(function(){
    if(blogItem > 4){
      $(this).addClass("blogdisplayvBlock");
    }
  });
  $(".guides-btn2").click(function(){
    $(".blogItem").each(function(){
      $(this).removeClass("blogdisplayvBlock");

    });
  });
  $('.btnqty').on('click', function(){
      var $parent = $(this).parent();
      var $input = $parent.find('.quantity-input');
      var qty = parseInt($input.val());
      var id = $input.attr('mulberry-data-id')
      if($(this).hasClass('qtyplus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $input.val(qty);
//       $parent.parent().find('.qtydiv').after('<span class="updating">Updating...</span>')
//       $input.parents('form:first').submit();
      var temp = jQuery.post('/cart/update.js', {
        updates: {
          [id]: qty
        }
      })
    if (window && window.mulberryShop) {
      temp.always(res => {
        fetch('/cart.js', {
           credentials: 'same-origin',
           method: 'GET',
           headers: {
             'Content-Type': 'application/json',
             'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
           }
         }).then(function (cart) {
           cart.json().then(function (firstCart) {
              mulberryShop.removeDetachedWarranty(firstCart)
            .then(newCart => {
                  mulberryShop.cart.syncQuantities(newCart)
                    .then(content => {
                    $(".cart__footer").load(location.href + " .cart__footer");
        //              window.location.href = window.location.href                    
                   })
              })
           });
        })
        })
      } else {
        $(".cart__footer").load(location.href + " .cart__footer");
       //   window.location.href = window.location.href        
      }      
    }); 
  
  $(".blink span").click(function(){
  	var burl = $(this).data("url");
    window.location.href=burl;
  });
  

});

/*$(".boost-pfs-filter-tree").load(function(){
 var optText = $(".boost-pfs-filter-option-title-text").text();
  
});*/

(function( func ) {
    $.fn.addClass = function(n) { // replace the existing function on $.fn
        this.each(function(i) { // for each element in the collection
            var $this = $(this); // 'this' is DOM element in this context
            var prevClasses = this.getAttribute('class'); // note its original classes
            var classNames = $.isFunction(n) ? n(i, prevClasses) : n.toString(); // retain function-type argument support
            $.each(classNames.split(/\s+/), function(index, className) { // allow for multiple classes being added
                if( !$this.hasClass(className) ) { // only when the class is not already present
                    func.call( $this, className ); // invoke the original function to add the class
                    $this.trigger('classAdded', className); // trigger a classAdded event
                }
            });
            prevClasses != this.getAttribute('class') && $this.trigger('classChanged'); // trigger the classChanged event
        });
        return this; // retain jQuery chainability
    }
})($.fn.addClass); // pass the original function as an argument

(function( func ) {
    $.fn.removeClass = function(n) {
        this.each(function(i) {
            var $this = $(this);
            var prevClasses = this.getAttribute('class');
            var classNames = $.isFunction(n) ? n(i, prevClasses) : n.toString();
            $.each(classNames.split(/\s+/), function(index, className) {
                if( $this.hasClass(className) ) {
                    func.call( $this, className );
                    $this.trigger('classRemoved', className);
                }
            });
            prevClasses != this.getAttribute('class') && $this.trigger('classChanged');
        });
        return this;
    }
})($.fn.removeClass);


// mega menu
function showMegaMenu(menu) {
  if (menu.timer) { clearTimeout(menu.timer) }
  menu.style.display = "block"
}

function hideMegaMenu(menu) {
  if (menu.timer) { clearTimeout(menu.timer) }

  menu.timer = setTimeout(() => {
    menu.style.display = "none"
  }, 20)
}

window.addEventListener('DOMContentLoaded', () => {
  const menuTrigger = document.querySelectorAll('.mega-menu-trigger')

  for (let trigger of menuTrigger) {
    const menu = trigger.querySelector('.mega-menu')

    trigger.addEventListener('mouseover', () => showMegaMenu(menu))
    trigger.addEventListener('mouseleave', () => hideMegaMenu(menu))
    menu.addEventListener('mouseleave', () => hideMegaMenu(menu))
  }
})

	
async function mulberryInit() {
  let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
  let product = response.product;
  
  const offer = await mulberry.core.getWarrantyOffer({
    id: product.id,
    title: product.title,
    price: window.selectedVariantPrice / 100,
    detail: product
  })
  
  if (offer.length <= 0) {
  	return
  }
  
  await mulberry.inline.init({
    offers: offer, 
    settings: mulberry.core.settings,
    selector: `#mulberry-inline-target`,
    onWarrantyToggle: async (warranty) => {
      if (warranty.isSelected) {
  		window.selectedWarranty = warranty.offer
      } else {
		window.selectedWarranty = null
      }
    }
  })
//  window.pdpModal = await mulberry.modal.init({
//     offers: offer, 
//     settings: mulberry.core.settings,
//     onWarrantySelect: async (warranty) => {
//       const result = await mulberryShop.getWarrantyVariant(warranty);
//       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, warranty);
//       mulberry.modal.close();
//        $('body').trigger('mulberry-load-pop-up')
//     },
//     onWarrantyDecline: () => {
//       mulberry.modal.close();
// 	  $('body').trigger('mulberry-load-pop-up')   
//     }
//   })
  
  $(`#mulberry-target-submit`).on('click', async () => {
    if (window && window.mulberryShop) {
      if (window.selectedWarranty) {
        setTimeout(async () => {
                           const result = await mulberryShop.getWarrantyVariant(window.selectedWarranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, window.selectedWarranty);
        $('body').trigger('mulberry-load-pop-up')
        window.selectedWarranty = null
        mulberry.inline.deselectOffer();
                   }, 750)
      } else {
//           window.pdpModal.open()
      }
    }                                  
  })
  
}
document.addEventListener('mulberry-shopify:warranty-added', () => {
  	  fetch('/cart.js', {
         credentials: 'same-origin',
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
         }
       }).then(function (cart) {
         cart.json().then(function (firstCart) {
            mulberryShop.removeDetachedWarranty(firstCart)
          .then(newCart => {
            	mulberryShop.cart.syncQuantities(newCart)
				  .then(content => {
                  	window.location.href = window.location.href
                 })
            })
         });
       });
});
document.addEventListener('mulberry-shopify:loaded', () => {
  if (window.location.href.indexOf('products') != -1) {
    mulberryInit();
  }
})
async function destringifyWarranty(newState) {  
	let arr = []
    let temp
	let refresh = false
    for(i=0;i<newState.items.length;i++) {
      item = newState.items[i]
      newProperties = {}
      for (const [key, value] of Object.entries(item.properties)) {
        temp = value
        if(key == '_warranty' && typeof value == 'string') {
          newProperties[key] = JSON.parse(value)
        }
        else {
          newProperties[key] = value
        }
        item.properties = newProperties
      }
      if(Object.keys(newProperties).length > 0) {
        try {
          response = await jQuery.post('/cart/change.js', {line: i+1, quantity: item.quantity, properties: newProperties})
          refresh = true
        } catch(e) {
          console.log('mulberry error: ', e);
        }          	
      }
      arr.push(item)
    }
  if (refresh) {
	window.location.href = window.location.href
  }
  refresh = false
}

$(document).ready(function() {
if (window.location.href.indexOf('cart') != -1) {
  fetch('/cart.js', {
         credentials: 'same-origin',
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           'X-Requested-With': 'XMLHttpRequest'
         }
       }).then(function (cart) {
         cart.json().then(function (firstCart) {          
            destringifyWarranty(firstCart)
         });
       });
}
})